import React, { useState } from "react";
import axios from "axios";
import { Loader2, Send, Check, ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const INTERESTS = [["consultancy", "Join the consultancy"], ["software", "License the software"], ["both", "Not sure yet"]];
const EMPTY = { name: "", email: "", phone: "", city: "", interest: "consultancy", message: "", website: "" };

const field = "h-12 w-full rounded-xl border border-white/10 bg-white/[0.03] px-4 text-sm text-white placeholder:text-muted-foreground/60 outline-none transition-colors focus:border-brand-red/60 focus:bg-white/[0.05]";

export const EnquiryForm = () => {
  const [f, setF] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.name.trim().length < 2) { setError("Please tell us your name."); return; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email)) { setError("That email doesn't look right."); return; }
    setSending(true);
    try {
      await axios.post(`${API}/public/enquiries`, f);
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Couldn't send — please try again in a moment.");
    } finally { setSending(false); }
  };

  if (sent) {
    return (
      <div data-testid="enquiry-success" className="rounded-2xl border border-brand-green/30 bg-brand-green/[0.07] p-8 text-center">
        <span className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-brand-green/20 text-brand-green"><Check className="h-6 w-6" /></span>
        <h3 className="mt-5 font-display text-xl font-semibold text-white">Got it, {f.name.split(" ")[0]}.</h3>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">A success manager will reply to <span className="text-white">{f.email}</span> — usually within one working day.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="enquiry-form" className="space-y-3">
      <div className="grid gap-3 sm:grid-cols-2">
        <input data-testid="enquiry-name" value={f.name} onChange={set("name")} placeholder="Your name" className={field} autoComplete="name" />
        <input data-testid="enquiry-email" value={f.email} onChange={set("email")} placeholder="Email" type="email" className={field} autoComplete="email" />
        <input data-testid="enquiry-phone" value={f.phone} onChange={set("phone")} placeholder="WhatsApp / phone (optional)" className={field} autoComplete="tel" />
        <input data-testid="enquiry-city" value={f.city} onChange={set("city")} placeholder="Where are you based?" className={field} />
      </div>
      <input tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} className="hidden" aria-hidden="true" />
      <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="What are you interested in">
        {INTERESTS.map(([k, l]) => (
          <button type="button" key={k} data-testid={`enquiry-interest-${k}`} onClick={() => setF((x) => ({ ...x, interest: k }))}
            className={`rounded-full border px-4 py-2 text-xs font-semibold transition-colors ${f.interest === k ? "border-brand-red/50 bg-brand-red/15 text-white" : "border-white/12 text-muted-foreground hover:text-white"}`}>{l}</button>
        ))}
      </div>
      <textarea data-testid="enquiry-message" value={f.message} onChange={set("message")} rows={4} placeholder="Tell us where you are on your journey — budget, city, timeline, anything that helps us reply properly."
        className={`${field} h-auto resize-none py-3`} />
      {error && <p data-testid="enquiry-error" className="text-sm text-brand-red">{error}</p>}
      <button type="submit" disabled={sending} data-testid="enquiry-submit"
        className="inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-brand-red font-semibold text-white shadow-lg shadow-brand-red/25 transition-colors hover:bg-brand-redDark disabled:opacity-60">
        {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Request access
      </button>
      <p className="flex items-center gap-1.5 text-xs text-muted-foreground"><ShieldCheck className="h-3.5 w-3.5 text-brand-green" /> Goes straight to the Moroccan Brothers team. No newsletters, no resale.</p>
    </form>
  );
};
